import { connect } from 'react-redux'
import { makeConditionSelector } from 'selectors/feature/conditions'
import { setConditionField } from 'actions/feature/conditions'
import { getSignal } from 'selectors/feature/inputs'
import InputValueEditor from './InputValueEditor'

const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()

  return (state, ownProps) => {
    const { uri } = ownProps
    const condition = conditionSelector(state, { queryUri: uri })
    const {
      value,
      dataType,
      translations,
      translationType,
      maxValue,
      minValue,
      units,
      inputConfig,
      signal,
      subType,
      definedSnaValues: conditionDefinedSnaValues = [],
      definedErrorValues: conditionDefinedErrorValues = [],
    } = condition

    // For signals with a top-level translation (e.g. native inputs), read definedSnaValues
    // from there. For DI pins with inputTranslations, the per-inputConfig translation may
    // provide definedSnaValues via the condition state (from mergeConditionWithSignal).
    const {
      translation: {
        definedSnaValues: signalDefinedSnaValues = [],
        definedErrorValues: signalDefinedErrorValues = [],
      } = {},
    } =
      getSignal(state, {
        signal,
      }) || {}

    const definedSnaValues =
      signalDefinedSnaValues.length > 0
        ? signalDefinedSnaValues
        : conditionDefinedSnaValues
    const definedErrorValues =
      signalDefinedErrorValues.length > 0
        ? signalDefinedErrorValues
        : conditionDefinedErrorValues

    return {
      value,
      dataType,
      translations,
      translationType,
      maxValue,
      minValue,
      units,
      inputConfig,
      definedSnaValues,
      definedErrorValues,
      signal,
      subType,
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatchSetConditionField: (conditionUri, field, val) => {
    dispatch(setConditionField(conditionUri, field, val))
  },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { subType, signal, ...restStateProps } = stateProps
  const { dispatchSetConditionField } = dispatchProps
  const { uri } = ownProps

  const onInputValueChange = (value) => {
    dispatchSetConditionField(uri, 'value', value)
  }

  return {
    ...ownProps,
    ...restStateProps,
    onInputValueChange,
  }
}

const InputValueEditorContainer = connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InputValueEditor)

export default InputValueEditorContainer
